(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('ScheduleController', ScheduleController);

    ScheduleController.$inject = ['Schedule'];

    function ScheduleController(Schedule) {

        var vm = this;

        vm.schedules = [];

        loadAll();

        function loadAll() {
            Schedule.query(function(result) {
                vm.schedules = result;
                vm.searchQuery = null;
            });
        }
    }
})();
